<template>
    <div>
        <Topbar :title="versionName" hasKeymap />
        <Main>
            <PhoneticInput
                @inputChanged="handleInputChange" />
            <PhoneticOutput />
            <PhoneticSuggestions/>
        </Main>
    </div>
</template>

<script>
import API from '../api/phonetic';
import _ from 'lodash';
import Cookie from 'js-cookie';
import { mapState } from 'vuex';
import PhoneticInput from '../components/PhoneticInput';
import PhoneticOutput from '../components/PhoneticOutput';
import Topbar from '../components/Topbar';
import PhoneticSuggestions from '../components/PhoneticSuggestions';
import Main from '../components/Main';

const sadakhataCookieName = 'sadakhata_cookie';
const dbApiConvert = _.debounce(API.PhoneticConvert, 20);

export default {
    name: 'Phonetic',
    components: {
        Main,
        PhoneticSuggestions,
        Topbar,
        PhoneticOutput,
        PhoneticInput
    },
    computed: {
        ...mapState({
            versionName: state => {
                let versionNames = {
                    basic: 'Sadakhata Basic',
                    dhusor: 'Dhusor Sadakhata',
                    shobdopata: 'Shobdopata',
                    shuvro: 'Shuvro Sadakhata'
                };

                return versionNames[state.phonetic.version];
            },
            version: state => {
                return state.phonetic.version;
            },
            sidebarActive: state => state.sidebar.active
        })
    },
    methods: {
        handleInputChange (text) {
            this.$store.commit('phonetic/UPDATE_INPUT', {
                text,
                sequence: this.$store.getters.phoneticInput.sequence + 1
            });
            let sadakhataCookie = Cookie.get(sadakhataCookieName) || '';
            dbApiConvert(this.version, text, this.$store.getters.phoneticInput.sequence, sadakhataCookie, response => {
                this.$store.commit('phonetic/UPDATE_INPUT', {
                    text: response.data.input,
                    sequence: response.data.sequence
                });
                this.$store.commit('phonetic/UPDATE_OUTPUT', {
                    text: response.data.output,
                    sequence: response.data.sequence,
                    suggestions: response.data.suggestions
                });

                const cookieValue = response.data.sadakhataCookie || '';
                const twoYearsInDays = 365 * 2;
                Cookie.set(sadakhataCookieName, cookieValue, { expires: twoYearsInDays });
            });
        },

        loadInitialText () {
            if (this.$store.getters.phoneticInput.sequence === 0) {
                this.handleInputChange('');
            }
        },

        updateVersion (version) {
            this.$store.commit('phonetic/UPDATE_VERSION', version);
            this.$store.commit('app/SET_PAGE_TITLE', this.versionName);
            this.loadInitialText();
        }
    },
    watch: {
        $route (to, from) {
            this.updateVersion(to.meta.version);
        }
    },
    mounted () {
        this.updateVersion(this.$route.meta.version);
    }
};
</script>
